import ruleTemplate from '@/http/requests/ruleTemplates'

export default {
  fetchPaginated({ commit }, data) {
    return new Promise((resolve, reject) => {
      ruleTemplate.fetchPaginated(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
        .then((response) => {
          const parsedData = response.data.data.getRuleTemplatePaginated;

          commit('SET_RULE_TEMPLATE_PAGINATED', parsedData);
          resolve(response);
        })
        .catch((exception) => {
          reject(exception);
        });
    })
  },
}
